var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControlLabel = void 0;
var FormControlLabel_1 = __importDefault(require("./FormControlLabel"));
exports.FormControlLabel = FormControlLabel_1.default;
exports.default = FormControlLabel_1.default;
//# sourceMappingURL=index.js.map